<button
    type="button"
    class="notif-bell"
    (click)="toggle($event)"
    pTooltip="Notificaciones"
    tooltipPosition="bottom"
>
    <i class="pi pi-bell text-lg"></i>
    @if (totalBadge() > 0) {
        <span class="notif-bell__badge">{{ totalBadge() }}</span>
    }
</button>

<p-popover #op styleClass="notif-popover">
    <div class="notif-panel">
        <!-- ── Aprobaciones pendientes ─────────────────────────────── -->
        <div class="notif-section">
            <div class="notif-section__head">
                <span>Aprobaciones pendientes</span>
                @if (approvalCount() > 0) {
                    <p-tag [value]="approvalCount().toString()" severity="danger"></p-tag>
                }
            </div>

            @if (approvalCount() === 0) {
                <div class="notif-empty">No tienes aprobaciones pendientes.</div>
            } @else {
                <div class="notif-list">
                    @for (step of pendingSteps(); track trackByStep($index, step)) {
                        <div class="notif-item">
                            <a class="notif-item__main" [routerLink]="['/approvals/review', step.approvalStepId]" (click)="op.hide()">
                                <i class="pi pi-check-square notif-item__icon"></i>
                                <div class="notif-item__body">
                                    <div class="notif-item__title">Aprobación de {{ entityLabel(step.entityType) }}</div>
                                    <div class="notif-item__sub">{{ stepSubtitle(step) }}</div>
                                </div>
                            </a>
                            <a class="notif-item__go" [routerLink]="['/approvals/review', step.approvalStepId]" (click)="op.hide()" pTooltip="Ir a aprobar" tooltipPosition="left">
                                <i class="pi pi-arrow-right"></i>
                            </a>
                        </div>
                    }
                </div>
            }
        </div>

        <div class="notif-divider"></div>

        <!-- ── Notificaciones generales (SuprSend) ─────────────────── -->
        <div class="notif-section">
            <div class="notif-section__head">
                <span>Notificaciones</span>
                @if (suprsendItems().length > 0) {
                    <button type="button" class="notif-mark-all" (click)="markAllRead()">Marcar todas leídas</button>
                }
            </div>

            @if (suprsendItems().length === 0) {
                <div class="notif-empty">No hay notificaciones.</div>
            } @else {
                <div class="notif-list">
                    @for (n of suprsendItems(); track trackByNotif($index, n)) {
                        <div class="notif-item" [class.notif-item--unseen]="!n.seen_on">
                            <button type="button" class="notif-item__main" (click)="onSuprsendClick(n)">
                                @if (!n.seen_on) { <span class="notif-item__dot"></span> }
                                <div class="notif-item__body">
                                    <div class="notif-item__title notif-clamp-1">{{ notificationTitle(n) }}</div>
                                    @if (notificationBody(n)) {
                                        <div class="notif-item__sub notif-clamp-2">{{ notificationBody(n) }}</div>
                                    }
                                </div>
                            </button>
                            <button type="button" class="notif-item__del" (click)="archive(n, $event)" pTooltip="Eliminar" tooltipPosition="left">
                                <i class="pi pi-times"></i>
                            </button>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</p-popover>
